import { ErrorMessage } from '@hookform/error-message';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import ServiceClassificationService from '../service';
import Select from 'react-select';
import { custom_select } from 'assets/styles/multiple_select';
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from 'reactstrap';
import FlexSelect from 'components/Inputs/FlexSelect';
import { toast } from 'react-toastify';
import Tour from 'reactour';
import { matrixSLAServiceClassificationsTourStepsInsideModal } from '../../../../utils/matrixSLATourSteps';
import { useSelector } from 'react-redux';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';

const ServiceClassificationModal = ({
  matrixSLA,
  modal,
  toggle,
  currentImpactCriticality = null,
  currentServiceClassification = null,
  reasonsWithSubreasons,
  fetchServiceClassification
}) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [tourOpen, setTourOpen] = useState(false);
  const defaultValues = {
    name: `${currentImpactCriticality?.impact?.name} > ${currentImpactCriticality?.crit?.name}`,
    reasonSubReasonClassification: [
      {
        reason: {
          id: '',
          subreson_id: []
        }
      }
    ]
  };
  const { handleSubmit, control, setValue, errors, reset, watch } = useForm({
    defaultValues
  });

  const {
    fields: fields,
    append,
    remove
  } = useFieldArray({
    control,
    name: 'reasonSubReasonClassification'
  });

  useEffect(() => {
    if (currentServiceClassification) {
      const formattedData =
        currentServiceClassification.reasonSubReasonClassification.reduce(
          (acc, item) => {
            const reasonId = item.reason ? item.reason.id : null;
            const subreason = item.subreason
              ? { label: item.subreason.name, value: item.subreason.id }
              : null;

            if (reasonId) {
              if (subreason) {
                const existingReason = acc.find(
                  (r) => r.id.value === reasonId && r.subreason_id.length > 0
                );
                if (existingReason) {
                  existingReason.subreason_id.push(subreason);
                } else {
                  acc.push({
                    id: { label: item.reason.name, value: reasonId },
                    subreason_id: [subreason]
                  });
                }
              } else {
                acc.push({
                  id: { label: item.reason.name, value: reasonId },
                  subreason_id: []
                });
              }
            } else {
              const reason = reasonsWithSubreasons.find((r) =>
                r.subreason.some((s) => s.id === subreason.value)
              );

              if (reason) {
                const existingReason = acc.find(
                  (r) => r.id.value === reason.id && r.subreason_id.length > 0
                );
                if (existingReason) {
                  if (subreason) {
                    existingReason.subreason_id.push(subreason);
                  }
                } else {
                  acc.push({
                    id: { label: reason.name, value: reason.id },
                    subreason_id: [subreason]
                  });
                }
              }
            }

            return acc;
          },
          []
        );

      reset({
        name: currentServiceClassification?.name,
        reasonSubReasonClassification: formattedData.map((item) => ({
          reason: {
            id: item.id.value,
            subreason_id: item.subreason_id.map((subitem) => {
              if (subitem) {
                return { label: subitem?.label, value: subitem?.value };
              } else {
                return null;
              }
            })
          }
        }))
      });
    }
  }, [currentServiceClassification, reset, reasonsWithSubreasons]);

  const handleSelectReason = (selectedReasonId, index) => {
    const reasonHasChange = selectedReasons[index] !== selectedReasonId;

    if (selectedReasonId === null || reasonHasChange) {
      setSelectedReasons({
        ...selectedReasons,
        [index]: selectedReasonId
      });
      setValue(
        `reasonSubReasonClassification[${index}].reason.subreason_id`,
        []
      );
    } else {
      setSelectedReasons({
        ...selectedReasons,
        [index]: selectedReasonId
      });
    }
  };

  const appendRow = () => {
    append({ reason: { id: '', subreason_id: [] } });
  };

  const removeRow = (index) => {
    remove(index);
  };

  const onSubmit = (data) => {
    let formattedData = null;
    const usrLogin = localStorage.getItem('login');
    if (currentServiceClassification) {
      formattedData = {
        name: data.name,
        reasonSubReasonClassification: data.reasonSubReasonClassification.map(
          (item) => {
            const subreasons = item.reason.subreason_id
              ? item.reason.subreason_id
                  .filter((subreason) => subreason !== null)
                  .map((subreason) => subreason.value)
              : null;

            return {
              reason: {
                id: item.reason.id,
                subreason_id:
                  subreasons && subreasons.length > 0 ? subreasons : null
              }
            };
          }
        )
      };
      ServiceClassificationService.updateServiceClassification(
        currentServiceClassification.id,
        formattedData,
        usrLogin
      )
        .then((response) => {
          toast.success(
            response.data.message ||
              'Classificação de Serviço atualizada com sucesso!'
          );
          toggle();
          fetchServiceClassification();
        })
        .catch((error) => {
          console.log(error);
          toast.error(
            error.response?.data?.message ||
              error.message ||
              'Erro ao excluir feriado!'
          );
        });
      return;
    }
    formattedData = {
      name: data.name,
      enabled: true,
      sla_matrix_id: matrixSLA.id,
      id_impacts_criticality: currentImpactCriticality.crit.value.id || null,
      reasonSubReasonClassification: data.reasonSubReasonClassification.map(
        (item) => {
          const subreasons = item.reason.subreason_id
            ? item.reason.subreason_id
                .filter((subreason) => subreason !== null)
                .map((subreason) => subreason.value)
            : null;

          return {
            reason: {
              id: item.reason.id,
              subreason_id:
                subreasons && subreasons.length > 0 ? subreasons : null
            }
          };
        }
      )
    };

    ServiceClassificationService.createServiceClassification(
      formattedData,
      usrLogin
    )
      .then((response) => {
        toast.success(
          response.data.message ||
            'Classificação de Serviço criada com sucesso!'
        );
        toggle();
        fetchServiceClassification();
      })
      .catch((error) => {
        console.log(error);
        toast.error(
          error.response?.data?.message ||
            error.message ||
            'Erro ao excluir feriado!',
          {
            autoClose: 5000
          }
        );
      });
  };

  const errorFormMessage = useCallback(
    (message) => <p style={{ color: 'red' }}>{message}</p>,
    []
  );

  const openTour = () => {
    setTourOpen(true);
  };

  const closeTour = () => {
    setTourOpen(false);
  };

  return (
    <Modal isOpen={modal} toggle={toggle} centered={true} size="lg">
      <ModalHeader toggle={toggle}>
        Classificações de Serviço da Matriz SLA
      </ModalHeader>
      <ModalBody>
        <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col
              md="6"
              className="tour-dt_matrix_sla_service_classifications_modal"
            >
              <label className="form-control-label text-capitalize">
                Nome da Classificação*
              </label>
              <Controller
                render={(props) => <Input type="text" {...props} />}
                control={control}
                name="name"
                defaultValue=""
                rules={{
                  required: 'Nome da Classificação é obrigatório.'
                }}
              />
              <ErrorMessage
                errors={errors}
                name="name"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
            <Col md="6">
              <label className="form-control-label">Categoria de Cliente</label>
              <Controller
                control={control}
                name="customerPortfolio"
                defaultValue=""
                render={() => (
                  <Input
                    type="text"
                    value={matrixSLA?.customerPortfolio?.name}
                    disabled={true}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="customerPortfolio"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>
          {fields.map((item, index) => (
            <Row key={item.id}>
              <Col
                md="6"
                className="tour-dt_matrix_sla_service_classifications_modal_reason"
              >
                <label className="form-control-label">Motivo</label>
                <Controller
                  render={(props) => (
                    <FlexSelect
                      dataOptions={
                        reasonsWithSubreasons
                          ? reasonsWithSubreasons.map((reason) => ({
                              label: reason.name,
                              value: reason.id
                            }))
                          : []
                      }
                      value={props.value}
                      valueController={setValue}
                      fieldName={`reasonSubReasonClassification[${index}].reason.id`}
                      labelName="label"
                      valueName="value"
                      isClearable={true}
                      closeMenuOnSelect={true}
                      portalTarget={true}
                      onChange={(event) => {
                        setValue(
                          `reasonSubReasonClassification[${index}].reason.id`,
                          event
                        );
                        handleSelectReason(event, index);
                      }}
                    />
                  )}
                  control={control}
                  rules={{
                    required: 'Selecione um motivo.'
                  }}
                  name={`reasonSubReasonClassification[${index}].reason.id`}
                  defaultValue={item.reason.id}
                />
                <ErrorMessage
                  errors={errors}
                  name={`reasonSubReasonClassification[${index}].reason.id`}
                  render={({ message }) => errorFormMessage(message)}
                />
              </Col>
              <Col
                md="6"
                className="tour-dt_matrix_sla_service_classifications_modal_subreason"
              >
                <label className="form-control-label">Submotivo</label>
                <Controller
                  render={() => {
                    const reasonId = watch(
                      `reasonSubReasonClassification[${index}].reason.id`
                    );
                    const reason = reasonsWithSubreasons.find(
                      (reason) => reason.id === reasonId
                    );
                    const dataOptions =
                      reason && reason.subreason
                        ? reason.subreason.map((subreason) => ({
                            label: subreason.name,
                            value: subreason.id
                          }))
                        : [];

                    return (
                      <Select
                        styles={{ ...custom_select, width: '100%' }}
                        options={dataOptions}
                        placeholder="Selecione..."
                        isMulti={true}
                        isClearable={true}
                        closeMenuOnSelect={false}
                        valueController={setValue}
                        name={`reasonSubReasonClassification[${index}].reason.subreason_id`}
                        value={
                          watch(
                            `reasonSubReasonClassification[${index}].reason.subreason_id`
                          ) || null
                        }
                        onChange={(value) => {
                          setValue(
                            `reasonSubReasonClassification[${index}].reason.subreason_id`,
                            value
                          );
                        }}
                        defaultValue={item.reason.subreason_id || []}
                      />
                    );
                  }}
                  control={control}
                  name={`reasonSubReasonClassification[${index}].reason.subreason_id`}
                  defaultValue={item.reason.subreason_id || []}
                />
                <ErrorMessage
                  errors={errors}
                  name={`reasonSubReasonClassification[${index}].reason.subreason_id`}
                  render={({ message }) => errorFormMessage(message)}
                />
              </Col>
            </Row>
          ))}
          <Row className="mt-3">
            <Col
              style={{
                display: 'flex',
                justifyContent: 'flex-start'
              }}
            >
              <Button
                className="tour-dt_matrix_sla_service_classifications_modal_add_reason"
                style={buttonStyle(systemConfiguration.primary_color)}
                size="sm"
                onClick={() => {
                  appendRow();
                }}
              >
                Adicionar Motivo
              </Button>
            </Col>
            <Col
              style={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <Button
                className="tour-dt_matrix_sla_service_classifications_modal_remove_reason"
                color="danger"
                size="sm"
                disabled={fields.length === 1}
                onClick={() => {
                  removeRow(fields.length - 1);
                }}
              >
                Remover
              </Button>
            </Col>
          </Row>
          <hr />
          <Row
            className="mt-3 ml-1"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingRight: '1rem'
            }}
          >
            <div>
              <Button style={buttonStyle(systemConfiguration.primary_color)}>
                Adicionar
              </Button>

              <Button
                color="danger"
                onClick={() => {
                  reset();
                  toggle();
                }}
              >
                Cancelar
              </Button>
            </div>
            <Button
              className="float-right "
              type="button"
              outline
              color="info"
              onClick={openTour}
              title="Saiba mais sobre as configurações das classificações de serviço"
            >
              Saiba Mais
            </Button>
            <Tour
              steps={matrixSLAServiceClassificationsTourStepsInsideModal}
              isOpen={tourOpen}
              onRequestClose={closeTour}
            />
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ServiceClassificationModal;
